import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import API_URL from '../config/api';
import './Login.css';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Auto-redirect if already logged in
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/dashboard');
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        console.log('🐞 Debug: Handle Login Clicked');
        console.log('🐞 Debug: Email:', email);
        console.log('🐞 Debug: Password:', password ? '********' : 'Empty');
        console.log('🐞 Debug: API URL:', API_URL);

        setError('');

        try {
            console.log('🐞 Debug: Starting fetch...');
            const response = await fetch(`${API_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                navigate('/dashboard');
            } else {
                setError(data.message || 'Error al iniciar sesión');
            }
        } catch (err) {
            setError('No se pudo conectar con el servidor.');
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <Link to="/" className="back-to-home">
                    <ArrowLeft size={18} />
                    <span>Volver al inicio</span>
                </Link>
                <div className="login-header">
                    <div className="login-logo-container">
                        <img
                            src="/logo.png"
                            alt="GeneCenter"
                            className="login-logo"
                        />
                    </div>
                    <p>Sistema de Gestión Clínica</p>
                </div>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label htmlFor="email">Usuario o Correo</label>
                        <input
                            id="email"
                            type="text"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Usuario o correo"
                            autoComplete="username"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </div>

                    <button type="submit" className="btn-login">
                        Ingresar
                    </button>
                </form>

                <div className="login-legal-footer">
                    <div className="login-legal-divider"></div>
                    <div className="login-legal-links">
                        <a href="/privacidad.html" target="_blank" rel="noopener noreferrer">
                            Política de Privacidad
                        </a>
                        <span className="login-legal-dot">•</span>
                        <a href="/terminos.html" target="_blank" rel="noopener noreferrer">
                            Términos de Servicio
                        </a>
                    </div>
                    <p className="login-legal-copy">&copy; 2026 GeneCenter. Todos los derechos reservados.</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
